import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Input, DatePicker, Select, Card, Checkbox, Button } from 'antd'
import moment from 'moment'

import Aliases from './Aliases'
import CategorySelect from '@components/CategorySelect'
import ProviderSelect from '@components/ProviderSelect'
import PolicyParentsPopup from '@components/Popup/PolicyParentsPopup'

import { policyType } from '@texts/policy'

@inject((store: any) => {
    const { providerStore, popupStore, policiesStore } = store
    return { providerStore, popupStore, policiesStore }
})
@observer
export default class Details extends Component<any, any> {
    handleEditPolicy = (name, value) => {
        this.props.detailsChanged({ name, value })
    }

    parentPolicyPopup = async () => {
        const { popupStore, policy, policiesStore } = this.props
        await policiesStore.getParentPolicies(policy['company_id'], policy['id'])
        popupStore.togglePopup('policyParents')
    }

    render() {
        const { disableEdit, editPolicy, policy, errors, hmoCompanies, providerStore } = this.props
        const disable = !disableEdit ? !!editPolicy.locked : true
        const { Option } = Select
        const styles = {
            input: { direction: 'ltr', textAlign: 'right' },
            title: { fontSize: '0.8rem', fontWeight: 500, width: '6rem', textAlign: 'right', display: 'inline-block' },
            select: { width: '100%' },
            date: { border: 'none', cursor: 'pointer', width: '100%' },
            cardHead: { borderBottom: 'none', backgroundColor: '#e1e3e7' },
            cardBody: { padding: '0.1rem', backgroundColor: '#fafafa' },
            cardStyle: { marginBottom: '0.5rem' },
            checkBox: { padding: '0.5rem' }
        } as React.CSSProperties

        return (
            <div className="edit-policy-wrapper">
                {errors['server'] ? <span className="server-error">{errors['server']}</span> : ''}
                <Card
                    type="inner"
                    size="small"
                    title="שם פוליסה מקורי (מקובץ PDF)"
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <Input
                        size="default"
                        disabled={disable}
                        value={editPolicy['name']}
                        onChange={e => this.handleEditPolicy('name', e.target.value)}
                    />
                    {errors['name'] ? <span className="field-error">{errors['name']}</span> : ''}
                </Card>

                <Card
                    type="inner"
                    size="small"
                    title="שמות פוליסה מקבילים לזיהוי"
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <Aliases
                        disabled={disable}
                        onSubmit={value => {
                            const newValue = value.length > 0 ? JSON.stringify(value) : null
                            this.handleEditPolicy('aliases', newValue)
                        }}
                        list={editPolicy['aliases'] ? JSON.parse(editPolicy['aliases']) : []}
                    />
                    {errors['aliases'] ? <span className="field-error">{errors['aliases']}</span> : ''}
                </Card>

                <CategorySelect
                    styles={styles}
                    categoryChanged={value => this.handleEditPolicy('category_id', value)}
                    disabled={disable}
                />
                {errors['category'] ? <span className="field-error">{errors['category']}</span> : ''}

                <Card
                    type="inner"
                    size="small"
                    title="שיוך לחברה"
                    extra={'חברת הביטוח אליה משתייכת הפוליסה'}
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <Input
                        style={{ ...styles['input'], direction: 'rtl' }}
                        size="default"
                        disabled={true}
                        value={editPolicy['company_name']}
                    />
                    {errors['company'] ? <span className="field-error">{errors['company']}</span> : ''}
                </Card>
                <Card
                    type="inner"
                    size="small"
                    title="סוג הפוליסה"
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <Select
                        value={editPolicy['type']}
                        onChange={e => this.handleEditPolicy('type', e)}
                        style={styles['select']}
                        disabled={disable}
                    >
                        <Option value="PRIVATE">{policyType['PRIVATE']}</Option>
                        <Option value="PUBLIC">{policyType['PUBLIC']}</Option>
                        <Option value="SHABAN">{policyType['SHABAN']}</Option>
                        <Option value="GROUP">{policyType['GROUP']}</Option>
                        <Option value="GLOBAL">{policyType['GLOBAL']}</Option>
                    </Select>
                    {editPolicy['type'] === 'GROUP' ? (
                        <Fragment>
                            <ProviderSelect
                                disable={disable}
                                providerSelected={() => this.handleEditPolicy('provider_id', providerStore.selectedId)}
                            />
                            {errors['providerError'] ? (
                                <span className="field-error">{errors['providerError']}</span>
                            ) : (
                                ''
                            )}
                        </Fragment>
                    ) : (
                        ''
                    )}
                    {editPolicy['type'] === 'SHABAN' ? (
                        <Fragment>
                            <Select
                                placeholder="בחר קופת חולים"
                                value={editPolicy['hmo_id'] ? editPolicy['hmo_id'] : undefined}
                                onChange={e => this.handleEditPolicy('hmo_id', e)}
                                style={{ ...styles['select'], marginTop: '0.2rem' }}
                                disabled={disable}
                            >
                                {hmoCompanies.map(company => (
                                    <Option value={company.id} key={company.id}>
                                        {company.name}
                                    </Option>
                                ))}
                            </Select>
                            {errors['shabanError'] ? <span className="field-error">{errors['shabanError']}</span> : ''}
                            <Checkbox
                                disabled={disable}
                                checked={editPolicy['hmo_plan']}
                                style={{ ...styles['checkBox'], width: '100%' }}
                                onChange={e => this.handleEditPolicy('hmo_plan', e.target.checked)}
                            >
                                זוהי פוליסת ביטוח רפואי משלים
                            </Checkbox>
                        </Fragment>
                    ) : (
                        ''
                    )}
                </Card>
                <Card
                    type="inner"
                    size="small"
                    title="שיוך לפוליסת הורה"
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <div
                        style={{
                            padding: '0.5rem 0.5rem 0.5rem 0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        {editPolicy['parent_id'] ? (
                            <a
                                style={{ textDecoration: 'underline' }}
                                target="_blank"
                                href={`/insurance/${policy['company_id']}/${editPolicy['parent_id']}`}
                            >
                                קיים שיוך לפוליסה מספר {editPolicy['parent_id']}
                            </a>
                        ) : (
                            'ללא שיוך'
                        )}
                        {!disable ? (
                            <div>
                                {editPolicy['parent_id'] ? (
                                    <Button onClick={() => this.handleEditPolicy('parent_id', null)}>הסר שיוך</Button>
                                ) : (
                                    ''
                                )}
                                <Button onClick={() => this.parentPolicyPopup()} size="small">
                                    עדכן שיוך פוליסה
                                </Button>
                            </div>
                        ) : (
                            ''
                        )}
                        {errors['name'] ? <span className="field-error">{errors['name']}</span> : ''}
                    </div>
                </Card>
                <Card
                    type="inner"
                    size="small"
                    title="תאריך תחילת שיווק הפוליסה"
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <DatePicker
                        allowClear={true}
                        value={editPolicy['release_date'] ? moment(editPolicy['release_date']) : null}
                        placeholder="לא נבחר תאריך תחילת שיווק הפוליסה"
                        format={'DD/MM/YYYY'}
                        style={styles['date']}
                        disabled={disable}
                        onChange={e => {
                            this.handleEditPolicy('release_date', e ? moment(e).format('YYYY-MM-DD HH:MM:SS') : null)
                        }}
                    />
                    {errors['releaseDateError'] ? (
                        <span className="field-error">{errors['releaseDateError']}</span>
                    ) : (
                        ''
                    )}
                </Card>
                <Card
                    type="inner"
                    size="small"
                    title="תאריך סיום שיווק הפוליסה"
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <DatePicker
                        allowClear={true}
                        value={editPolicy['expiration_date'] ? moment(editPolicy['expiration_date']) : null}
                        placeholder="לא נבחר תאריך תפוגה"
                        format={'DD/MM/YYYY'}
                        style={styles['date']}
                        disabled={disable}
                        onChange={e => {
                            this.handleEditPolicy('expiration_date', e ? e.format('YYYY-MM-DD HH:MM:SS') : null)
                        }}
                    />
                </Card>
                <Card
                    type="inner"
                    size="small"
                    title="סוג הפיצוי"
                    extra={'הגדרת סוג הפיצוי של הפוליסה'}
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <Select
                        value={editPolicy['compensation_type']}
                        onChange={e => this.handleEditPolicy('compensation_type', e)}
                        style={styles['select']}
                        disabled={disable}
                    >
                        <Option value="COMPENSATION">פיצוי חד פעמי</Option>
                        <Option value="CUMULATIVE">פיצוי מצטבר</Option>
                        <Option value="ALLOWANCE">פיצוי קצבה</Option>
                        <Option value="INDEMNIFICATION">שיפוי</Option>
                    </Select>
                </Card>
                <Card
                    type="inner"
                    size="small"
                    title="תקופת התחדשות"
                    extra={'הגדרת תקופה שבה הפוליסה מתחדשת'}
                    style={styles['cardStyle']}
                    headStyle={styles['cardHead']}
                    bodyStyle={styles['cardBody']}
                >
                    <Select
                        value={editPolicy['insurance_period_type']}
                        onChange={e => this.handleEditPolicy('insurance_period_type', e)}
                        style={styles['select']}
                        disabled={disable}
                    >
                        <Option value="מתחדש">מתחדש</Option>
                        <Option value="לכל החיים">לכל החיים</Option>
                        <Option value="פרמיה לחודש">פרמיה לחודש</Option>
                    </Select>
                </Card>
                <PolicyParentsPopup addParentPolicy={value => this.handleEditPolicy('parent_id', value)} />
            </div>
        )
    }
}
